import { useEffect, useState } from "react";
import { Form, FormControl, FormGroup } from "react-bootstrap";
import { Axios } from "../../Api/axios";
import LoadingSubmit from "../Loading/Loading";
import { useNavigate, useParams } from "react-router-dom";

/**
 * Generic edit form for entities with a title and optional image.
 * Props:
 *   fetchEndpoint  — base URL to GET /:id
 *   saveEndpoint   — base URL to POST /edit/:id
 *   redirectPath   — where to navigate after a successful save
 */
export default function EntityEditForm({ fetchEndpoint, saveEndpoint, redirectPath }) {
  const [title, setTitle] = useState("");
  const [image, setImage] = useState("");
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);

  const nav = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);
    Axios.get(`${fetchEndpoint}/${id}`)
      .then((data) => {
        setTitle(data.data.title);
        setLoading(false);
        setDisable(false);
      })
      .catch(() => nav(redirectPath, { replace: true }));
  }, [id, nav, fetchEndpoint, redirectPath]);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("title", title);
    if (image) formData.append("image", image);
    try {
      await Axios.post(`${saveEndpoint}/edit/${id}`, formData);
      nav(redirectPath);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }

  return (
    <>
      {loading && <LoadingSubmit />}
      <Form className="white w-100 px-4 py-3 rounded shadow-sm" onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="entityTitle">
          <Form.Label>Title</Form.Label>
          <Form.Control
            value={title}
            required
            onChange={(e) => setTitle(e.target.value)}
            type="text"
            placeholder="Title..."
          />
        </Form.Group>
        <FormGroup className="mb-3" controlId="entityImage">
          <Form.Label>Image</Form.Label>
          <FormControl
            onChange={(e) => setImage(e.target.files.item(0))}
            type="file"
          />
        </FormGroup>
        <button disabled={disable} className="btn btn-primary">
          Save
        </button>
      </Form>
    </>
  );
}
